import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: "s32ep53c",
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: true,
  token:
    "ska1eImTRygR9EmKPVAWac9YipryoLwj0ZHrcFhz0V5Zap3iKSA0DZ24QsyzSRsla8CTjgTCilBWZL7Y9Nc7X4HtfuHRuxE1jUErlG1xdP3MPr9ZA9tK1LrmkGCzs6bPJyZqQgEjRqVpcwGptOkagbV0yWFpB5v44EGEOowBETKb8PqxRm15",
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
